module.exports = __webpack_public_path__ + "static/media/substance-abuse.e2a8e807.svg";